var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHandWaving(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4609 13.2118C18.9659 12.2655 18.8557 11.1645 19.1532 10.1388C19.4508 9.11316 20.1331 8.24212 21.0577 7.70767C21.9823 7.17321 23.0777 7.01668 24.115 7.27076C25.1523 7.52484 26.0513 8.16988 26.6242 9.07115L32.8352 19.8161",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9539 20.2095L10.6414 14.4747C10.1463 13.5284 10.0361 12.4274 10.3336 11.4018C10.6312 10.3761 11.3136 9.50506 12.2382 8.97061C13.1628 8.43615 14.2581 8.27962 15.2954 8.5337C16.3327 8.78777 17.2317 9.43282 17.8046 10.3341L24.8437 22.5282",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8829 34.7223C31.3374 33.7821 30.9828 32.7434 30.8395 31.6659C30.6961 30.5883 30.7669 29.4931 31.0477 28.4429C31.3285 27.3928 31.8139 26.4084 32.4759 25.5462C33.1379 24.684 33.9635 23.9609 34.9055 23.4184L32.8352 19.8161C32.2861 18.8634 32.138 17.7317 32.4234 16.6698C32.7087 15.6079 33.4042 14.7029 34.3569 14.1538C35.3096 13.6047 36.4413 13.4566 37.5032 13.7419C38.5651 14.0273 39.4701 14.7228 40.0192 15.6755L44.1598 22.8594C46.3562 26.6646 46.9509 31.1864 45.8133 35.43C44.6757 39.6737 41.8989 43.2916 38.0938 45.488C34.2887 47.6843 29.7669 48.2791 25.5232 47.1415C21.2796 46.0039 17.6616 43.2271 15.4653 39.422L6.76999 24.3501C6.49811 23.8784 6.3218 23.3577 6.25114 22.8179C6.18047 22.278 6.21682 21.7296 6.35812 21.2038C6.64349 20.1419 7.33901 19.2369 8.29167 18.6878C9.24432 18.1387 10.3761 17.9905 11.438 18.2759C12.4999 18.5613 13.4049 19.2568 13.954 20.2094L18.5087 28.0973",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7902 50.1875C13.9771 48.2472 11.6353 45.7002 9.9375 42.7344",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4375 6.91801C38.3274 6.91289 40.1849 7.40823 41.8212 8.35368C43.4576 9.29914 44.8145 10.661 45.7539 12.3008",
    stroke: "#2C3B60",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandWaving);
export default __webpack_public_path__ + "static/media/HandWaving.01b26e6d0bd5141bed071af75eef1a00.svg";
export { ForwardRef as ReactComponent };